<template>
  <LayoutTelas
    id="tela__pagarbarbeiro"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">
    <PagarBarbeiroForm
      @buscar="buscar"
      @limpar="limpar" />

    <div
      class="lucros__item"
      v-if="valoresPagar">
      <p class="lucros__item__titulo">
        Valor a pagar para o barbeiro
      </p>
      <p class="lucros__item__valor">
        {{ valoresPagar.totalFuncionario | currency }}
      </p>
      <p class="lucros__item__titulo">
        Quantidade de atendimentos
      </p>
      <p class="lucros__item__valor">
        {{ valoresPagar.atendimentos }}
      </p>
    </div>

  </LayoutTelas>
</template>

<script>
import PagarBarbeiroForm from './PagarBarbeiroForm.vue'
import GeradorMensagens from '@/mixins/GeradorMensagens'

import PagarBarbeiroService from '../../services/pagarbarbeiro.service'

export default {
  name: 'PagarBarbeiro',
  components: {
    PagarBarbeiroForm,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      valoresPagar: null,
      isLoading: false,
    }
  },
  methods: {
    async buscar(filtro) {
      this.limpar()
      this.mostrarLoader()
      try {
        const servicos = await PagarBarbeiroService.buscaFiltroFuncionario(filtro)
        this.valoresPagar = servicos
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    limpar() {
      this.valoresPagar = null
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";
@import "@/scss/colors.scss";

#tela__pagarbarbeiro {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

.lucros__item {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__titulo {
    font-weight: 300;
  }

  &__valor {
    font-size: 1.5rem;
    font-weight: 500;
    color: $cor-verde;
  }
}

</style>
